export abstract class TokenGateway {
    abstract clearStorage(): void;
    abstract saveToken(token: string): void;
    abstract saveRefreshToken(token: string): void;
    abstract getToken(): string | null;
    abstract getRefreshToken(): string | null;
    abstract saveUser(user: any): void;
    abstract getUser(): any;
    abstract saveModel(model: string, key: string): any;
    abstract getModelKey(key: string): any;
}